import { useForm } from "react-hook-form";
import { ILogInInterface } from "../interface/login.interface";
import { loginSchema } from "../validations/login.validation";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { HttpService } from "../../../../../services/base.service";
import { getIsLoading, getToken, getUser } from "../../../slice/user.selector";
import { useEffect } from "react";
import { routes } from "../../../../../router/routes";
import { Toast } from "../../../../../utils/Toast";
import { LoginUser } from "../../../slice/auth.thunks";
import { useState } from "react";
import storageService from "../../../../../utils/local-storage.utils";
import { userService } from "../../../../../services/user.service";
import { setLogin, setLogout } from "../../../slice/user.slice";
import { IApiErrorPayload, isTwoFactorRequired } from "../../../constants/auth-error.constants";
import { twoFactorService } from "../../../../../services/two-factor.service";
import TwoFactorModal from "../../../components/TwoFactorModal";

export const AdminLoginForm = () => {
    const [isLoading, setIsloading] = useState(false);
    const dispatch = useDispatch();
    let history = useHistory();
    const token = useSelector(getToken);
    const {role} = useSelector(getUser)

    useEffect(() => {
        const activeToken = token || storageService.getItem<string>('token');
        if (activeToken) {
            HttpService.setToken(activeToken);
            if(role == "USER"){
                history.push(routes.home);
            }else {
                history.push(routes.adminDashboard);
            }
        }
    }, [])
    const { register, handleSubmit, formState: { errors } } = useForm<any>({
        resolver: yupResolver(loginSchema)
    });
    const [challenge, setChallenge] = useState<IApiErrorPayload | null>(null);

    const onSubmit = async (data: ILogInInterface) => {
        setIsloading(true)
        data.email = data.email.toLowerCase();
        const res: any = await dispatch(LoginUser(data));
        setIsloading(false)
        const payload: IApiErrorPayload = res?.payload ?? {};

        // Admins are not exempt from an organization's second factor. Without
        // this branch the else below fires and logs them out silently.
        if (isTwoFactorRequired(payload)) {
            setChallenge(payload);
            return;
        }

        if (payload.statusCode == 200 && (res.payload.payload?.user?.role == "ADMIN")) {
            Toast.fire({
                icon: "success",
                title: 'Welcome back'
            })
            history.push(routes.adminDashboard);
            return;
        }

        // Previously every failure landed here with no feedback at all.
        dispatch(setLogout());
        Toast.fire({
            icon: 'warning',
            title: payload.statusCode == 200
                ? 'This account is not a platform admin.'
                : payload.message || 'Unable to sign in. Please try again.'
        })
    };

    const completeTwoFactor = async (challengeToken: string, otpCode: string) => {
        const res: any = await twoFactorService.verify({ challengeToken, otpCode });
        if (res.payload.user?.role !== 'ADMIN') {
            dispatch(setLogout());
            setChallenge(null);
            Toast.fire({ icon: 'warning', title: 'This account is not a platform admin.' });
            return;
        }
        dispatch(setLogin({ token: res.payload.token, user: res.payload.user }));
        Toast.fire({ icon: 'success', title: 'Welcome back' });
        history.push(routes.adminDashboard);
    };
    if (challenge) {
        return (
            <TwoFactorModal
                challenge={challenge}
                onVerified={completeTwoFactor}
                onCancel={() => setChallenge(null)}
            />
        );
    }
    return (
        <form className="up-formtheme up-formsignin" onSubmit={handleSubmit(onSubmit as any)}>
            <fieldset>
                <div className="form-group">
                    <label>Email address</label>
                    <input type="email"
                        {...register("email")} className="form-control" placeholder="Enter Email" />
                    <small id="emailHelp" className="form-text text-muted">
                        {errors.email?.message}
                    </small>
                </div>
                <div className="form-group">
                    <label>Password</label>
                    <input type="password"
                        {...register("password")}
                        className="form-control" placeholder="Enter Password" />
                    <small id="emailHelp" className="form-text text-muted">
                        {errors.password?.message}
                    </small>
                </div>
                <div className="form-group">
                    {/* <div className="up-remebermearea">
                        <input type="checkbox" name="checkbox" id="up-rememberme" />
                        <label htmlFor="up-rememberme">Remember me</label>
                    </div> */}
                    <button type="submit" className="up-btn up-btnwithloader">Sign in {isLoading && <div className="lds-dual-ring"></div>}</button>
                </div>
            </fieldset>
        </form>
    )
};